export default __webpack_public_path__ + "static/media/win.0418153d.png";